import {GlobalVariables} from "../GlobalVariables";
import {gsap, Observer, ScrollTrigger} from "../LibrariesImport";

export default class BlockCta {
	static init() {
		this.blocks = document.querySelectorAll(".block-cta");
		this.blocks.forEach( block => {

            this.titles = block.querySelector(".title");
			this.titleLines = block.querySelectorAll(".title-line");
			this.titleLines.forEach(title => {
				gsap.fromTo(title, {
					xPercent: title.dataset.from,
				},{
					xPercent: 0,
					scrollTrigger: {
						trigger: this.titles,
						start: "top 100%",
						end: "center center",
						scrub: 1
					}
				});
			});

		});
	}

}
